/*

    This file is part of Universal Sequencer.
    Universal Sequencer is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequencer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React, { Component } from 'react';
import Waveform from 'components/Waveform.js';
import { withRouter } from 'react-router';

import Tone from 'tone';
import ConditionedComponent from 'components/ConditionedComponent.js';
import DMCAModal from 'components/modals/DMCAModal.js';
import axios from 'axios';
import YoutubeInfo from 'components/Youtube.js';
import {setShowSamples2D} from 'actions/index.js';
import {ADD_SOUND_BUTTON} from 'constants/contextual-help.js';
import { Badge, Card, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import AudioUnit from 'engine/audio.js';
import ethereum from 'decentralized/ethereum.js';
import { connect } from "react-redux";
import {setShowConvolverModal} from 'actions/index.js';
import {setSampleToExplore} from 'actions/index.js';
import {setContextualHelp} from 'actions/index.js';
import {setSimilarSoundsToFind} from 'actions/index.js';
import ChordSearcher from 'decentralized/chords/ChordSearcher.js';
import {LAYER_BUTTON, AUDITION_BUTTON, CONVOLVER_BUTTON} from 'constants/contextual-help.js';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import createHistory from "history/createBrowserHistory"
import Sample from 'repos/Sample.js';
import {SIMILAR_SOUNDS} from 'constants/selector-events.js';
import '../favorites.css';

class Sound extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: undefined,
            soundId: props.soundId,
            selections: [],
            favorited: false,
            density: undefined,
            tags: [],
            videoId: '',
            slices: [],
            waveforms: 0,
            dropdownOpen: false,
            showDMCAModal: false,
            guildName: undefined,
        };


        this.selectedSlices= [];
        this.slices = {};
        this.originalSoundId = this.state.soundId;
        this.handleLoadBuffer.bind(this);
        this.undoCropStack = [];
        this.undoCropIdStack = [];
        if (this.props.sample !== undefined) {
            this.audioUnit = this.props.audioUnit;
            this.loadSample(this.props.sample);
            this.state.slices = this.props.chordSlices;
        } else {
            this.sample = new Sample(
                props.soundId !== undefined ? props.soundId : props.soundHash);
            this.state.videoId = this.props.videoId;
            this.state.name = this.props.name;
            this.audioUnit.loadRawBuffer(this.props.buffer);
            this.state.buffer = this.props.buffer;
            this.state.waveforms++;
            this.setState(this.state);
        }

        //this.getUserName();
    }

    /*
    async getUserName() {
        let id = this.sample.getId();
        let userName = await ethereum.getUserNameForSound(id);
        this.setState({userName: userName});
    }
    */

    exploreSample() {
        this.props.setSampleToExplore(this.sample);
    }

    toggleDropdown() {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }

    async loadFavorites(ipfsHash) {
        let favorites = await ethereum.getFavoritesForSound(ipfsHash);
        if (favorites.userFavorited > 0) {
            this.setState({favorited: true});
        } else {
            this.setState({favorited: false});
        }
    }

    async loadChords() {
        let chordSelected = this.props.sequencerEngine.store.getState().selector.chordSelected;
        if (chordSelected === undefined) {
            return;
        }
        
        let noteSequence = await this.sample.fetchNoteSequence();

        if (noteSequence === undefined) {
            return;
        }

        let slices = new ChordSearcher().getChordsFromSequence(noteSequence, chordSelected);
        this.state.slices = slices;
        this.setState(this.state.slices);
    }

    onConvolver() {
        this.props.setShowConvolverModal(true, this.sample.ipfsHash);
        /*
        let sends = this.props.sequencerEngine.sends.sends;
        for (let i in sends) {
            let effects = sends[i].effects;
            for (let j in effects) {
                if (effects[j].name === 'Convolver Reverb') {
                    effects[j].setConvolverSample(this.sample.ipfsHash);
                }
            }
        }
        */
    }

    onClickFavorite() {
        if (!this.state.favorited) {
            ethereum.favoriteSound(this.sample.ipfsHash);
            this.setState({favorited: true});
        } else {
            ethereum.unfavoriteSound(this.sample.ipfsHash);
            this.setState({favorited: false});
        }
    }

    shouldComponentUpdate(nextProps) {
        let ret = false;
        if (nextProps.audioUnit !== this.audioUnit) { 
            if (nextProps.sample.getId() !== this.sample.getId() && this.audioUnit) {
                this.audioUnit.dispose();
            }
            this.audioUnit = nextProps.audioUnit;
            this.loadSample(nextProps.sample);
        }
        if ((nextProps.soundId != this.state.soundId && nextProps.soundId != this.originalSoundId) || 
            nextProps.sample.ipfsHash !== this.state.ipfsHash) {
            this.state.soundId = nextProps.soundId;
            this.state.slices = this.props.chordSlices;
        } 

        return true;
    }

    onChooseSlice(slice) {
        this.selectedSlices = [slice];
    }

    onSelectSlice(slice) {
        if (slice === undefined) {
            this.selectedSlices=  [];
            return; 
        }
        let index = this.selectedSlices.indexOf(slice);
        if (index > -1) {
            this.selectedSlices.splice(index, 1);
        } else {
            this.selectedSlices.push(slice);
        }
    }

    async loadSample(sample) {
        if (sample.ipfsHash === undefined) {
            return;
        }
        if (this.sample && this.sample !== sample) {
            this.sample.dispose();
        }
        this.sample = sample;
        this.state.ipfsHash = sample.ipfsHash;
        if (sample.tags !== undefined) {
            this.state.tags = sample.tags;
        }
        this.state.videoId = sample.videoId;
        this.setState(this.state);

        if (this.state.videoId === undefined) {
            this.state.name = sample.name;
            this.setState({name: sample.name});
        }

        this.handleLoadBuffer(this, sample.audioBuffer);
        this.loadFavorites(sample.ipfsHash);
        this.loadChords();

        if (this.sample.guildId === 0 || this.sample.guildId === undefined) {
            this.setState({guildName: undefined});
        } else {
            let name = await ethereum.guilds.getGuildName(this.sample.guildId);
            this.setState({guildName: name});
        }
   }

    handleLoadBuffer(self, buffer) {
        var state = self.state;
        state['buffer'] = buffer;
        self.setState(state);
    }
    
    onClickSelection(soundId, buffer) {
        this.undoCropStack.push(buffer);
        this.undoCropIdStack.push(this.state.soundId);
        this.state.soundId = soundId;
        this.state.waveforms+=2;
        this.setState(this.state);
    }

    sequence() {
        this.props.history.push('/create/' + this.state.soundId);
    }

    onHoverSlice(slice) {
        this.setState({density: slice.density});
    }

    addSample() {
        if (this.sample.audioBuffer === undefined) {
            // haven't downloaded yet
            return;
        }
        document.activeElement.blur()
        this.props.onAddSample(
            this.sample, this.selectedSlices);
    }

    onLayer() {
        if (this.sample.audioBuffer === undefined) {
            // haven't downloaded yet
            return;
        }
        this.props.onLayerSample(
            this.sample);
    }

    onAudition() {
        if (this.sample.audioBuffer === undefined) {
            // haven't downloaded yet
            return;
        }
        this.props.onAudition(this.sample);
    }

    onDownvote() {
        ethereum.unfavoriteSound(this.sample.ipfsHash);
    }

    similarSounds() {
        let id = this.sample.getId();
        this.props.setSimilarSoundsToFind(id);
        // this.props.setShowSamples2D(true);
        window.dispatchEvent(new Event(SIMILAR_SOUNDS));
    }

    formatTag(tag) {
        if (tag.length > 20) {
            tag = tag.slice(0, 20);
        }

        return tag;
    }


    componentWillUnmount() {
        if (this.audioUnit) {
            this.audioUnit.dispose();
        }

        if (this.sample) {
            this.sample.dispose();
        }
        
    }

    dmcaTakeDown(flag=true) {
        this.setState({
            showDMCAModal: flag 
        });
    }

    render() {
        var self = this;
        let className = "sound-row";
        if (this.props.auditioning) {
            className += ' auditioning';
        }
        if (this.props.i % 2 === 0) {
            className += ' odd';
        }
        return (
            <div className={className}>
              <DMCAModal hide={() => this.dmcaTakeDown(false)} show={this.state.showDMCAModal} sampleHash={this.sample.getId()}/>
                  <a name={"sample-" + this.sample.ipfsHash}/>
                  <div className={this.props.i % 2 == 0 ? "playlist-row" : "playlist-row odd"}>
                    <div className="sound-and-tags">
                      <ConditionedComponent condition={this.audioUnit !== undefined}>
                        <Waveform selections={this.state.selections} 
                              buffer={this.audioUnit === undefined ? undefined : this.audioUnit.buffer}
                      audioUnit={this.audioUnit}
                      sample={this.props.sample}
                      slices={this.state.slices}
                      onChooseSlice={(slice) => this.onChooseSlice(slice)}
                      onHoverSlice={(slice) => this.onHoverSlice(slice)}
                      sequencerEngine={this.props.sequencerEngine}
                      onSelectSlice={(slice) => this.onSelectSlice(slice)}
                      waveformId={this.state.waveforms}></Waveform>
                      </ConditionedComponent>
                      <ConditionedComponent condition={this.audioUnit === undefined}>
                        <div className="downloading-sample">Downloading sample...</div>
                      </ConditionedComponent>
                    <div className="sample-tags">
                    <div className="tags-sound-wrapper">
                      <div className="sample-name">
                        <span className="name-text">
                          {truncateName(this.props.sample.name)}
                        </span>
                        <ConditionedComponent condition={this.state.guildName}>
                          <span className="name-text guild-name-text">
                            {this.state.guildName}
                          </span>
                        </ConditionedComponent>
                      </div>
                      {this.props.sample.tags !== undefined ? 
                          this.props.sample.tags.map((tag) => <Badge color="light">{this.formatTag(tag)}</Badge>) :
                       '' }
                    </div>
                   </div>
                    <div className="clear-fix"></div>
                    </div>
                    <div className="youtube-info">
                      <YoutubeInfo
                        contextualHelp={ADD_SOUND_BUTTON}
                        hideName={this.props.hideName}
                        onClickThumbnail={() => this.addSample()}
                        isBig={true}
                        coverArt={this.sample.coverArtHash}
                        isSelector={true}
                        name={this.sample.name}
                        isMuted={false}
                        sample={this.sample}
                        onNewSound={this.props.onNewSound}>
                      </YoutubeInfo>
                      <div className="sound-buttons">
                        <div className="preset-dropdown">
                          <ButtonDropdown
                               size="sm"
                               show={this.state.dropdownOpen}
                               isOpen={this.state.dropdownOpen}
                               toggle={() => this.toggleDropdown()}>
                                   <Button
                                         onClick={() => this.addSample()}
                                         id="caret" color="secondary"><span className="medium">+</span></Button>
                               <DropdownToggle size="sm" caret color="secondary">
                               </DropdownToggle>
                       <DropdownMenu>
                       <DropdownItem
                       onMouseOver={() => this.props.setContextualHelp(ADD_SOUND_BUTTON)}
                       onMouseLeave={() => this.props.setContextualHelp(undefined)}
                                       onClick={() => {
                                           this.addSample();
                                       }}
                                   size="sm">ADD SOUND
                                 </DropdownItem>
                       <DropdownItem
                       onMouseOver={() => this.props.setContextualHelp(AUDITION_BUTTON)}
                       onMouseLeave={() => this.props.setContextualHelp(undefined)}
                       onClick={() => this.onAudition()} size="sm">AUDITION</DropdownItem>
                       <DropdownItem
                       onMouseOver={() => this.props.setContextualHelp(CONVOLVER_BUTTON)}
                       onMouseLeave={() => this.props.setContextualHelp(undefined)}
                       onClick={() => this.onConvolver()} size="sm">CONVOLVER</DropdownItem>
                       </DropdownMenu>
                             </ButtonDropdown>
                          </div>
                        <div onClick={() => this.onClickFavorite()} className={this.state.favorited ? "result-heart heart favorited" : "result-heart heart"}></div>
                      </div>
                    </div>
                  </div>
                </div>
            );
    }

    save() {
        var fd = new FormData();
        var self = this;
        
        // start a new worker 
        // we can't use Recorder directly, since it doesn't support what we're trying to do
        var worker = new Worker('/recorderWorker.js');
        
        // initialize the new worker
        worker.postMessage({
                command: 'init',
                    config: {sampleRate: Tone.context.sampleRate,
                        numChannels: self.audioUnit.buffer.numberOfChannels}
            });
        
        var name = 'cropped at ' + new Date();
        var url = "/saveCropped/" + name  +"/" + self.state.soundId + '/' + self.state.selection.start + '/' + self.state.selection.end;
        
        // callback for `exportWAV`
        worker.onmessage = function( e ) {
            var blob = e.data;
            fd.append('body', blob);
            axios({
                    method: 'POST',
                        url: url,
                        data: blob,
                        headers: {'Content-Type': 'application/octet-stream'}
                        }).then(function(ret) {
                                self.undoCropIdStack.push(self.state.soundId);
                                self.state['soundId'] = ret.data.soundId;
                                self.props.onSoundIdChange(ret.data.soundId);
                                //self.props.history.push('/sound/' + self.state['soundId']);
                            });
        };
        
        var buffer = [self.audioUnit.buffer.getChannelData(0)];
        if (self.audioUnit.buffer.numberOfChannels == 2) {
            buffer.push(self.audioUnit.buffer.getChannelData(1));
        } 
        
        // send the channel data from our buffer to the worker
        worker.postMessage({
                command: 'record',
                    buffer: buffer
                    });
        
        // ask the worker for a WAV
        worker.postMessage({
                command: 'exportWAV',
                    type: 'audio/wav'
                    });
    }
}

class TagButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showInputField: false,
            value: '',
        };
    }

    onKeyPress(e) {
        if (e.key === 'Enter') {
            ethereum.tagSample(this.props.sample.getId(), this.state.value);
            this.setState({showInputField: false});
        }
    }

    onClickAdd() {
        this.setState({showInputField: true});
    }
    
    render() {
        return (
            <div className="tag-sound-button">
              {this.state.showInputField ?
                      <InputGroup className="tag-sound-input">
                  <Input onChange={(event) => {this.state.value = event.target.value; this.setState(this.state);}}
                    value={this.state.value}
                    onKeyUp={(e) => this.onKeyPress(e)}
                    placeholder="Tag this sound" className="tag-sound-input-box"/>
                </InputGroup>
                      : <div onClick={() => this.onClickAdd()}>+</div>}
            </div>
        );
    }
}

function crop(buffer, start, end, ctxt) {
    var startFrame = start * Tone.context.sampleRate;
    var endFrame = end * Tone.context.sampleRate;
    var buff = ctxt.createBuffer(buffer.numberOfChannels, endFrame - startFrame + 1, ctxt.sampleRate);
    var left = buff.getChannelData(0);

    var origLeft = buffer.getChannelData(0).subarray(startFrame, endFrame);

    left.set(origLeft);
    if (buffer.numberOfChannels > 1) {
	var right = buff.getChannelData(1);
	var origRight = buffer.getChannelData(1).subarray(startFrame, endFrame);
	right.set(origRight);
    }

    return buff;
}

function exportAsWAV(url, audioBuffer, callback) {
    var fd = new FormData();
        var self = this;
        
        // start a new worker 
        // we can't use Recorder directly, since it doesn't support what we're trying to do
        var worker = new Worker('/recorderWorker.js');
        
        // initialize the new worker
        worker.postMessage({
                command: 'init',
                    config: {sampleRate: Tone.context.sampleRate,
                        numChannels: 2}
            });
        
        // callback for `exportWAV`
        worker.onmessage = function( e ) {
            var blob = e.data;
            fd.append('body', blob);
            axios({
                    method: 'POST',
                        url: url,
                        data: blob,
                        headers: {'Content-Type': 'application/octet-stream'}
                        }).then(function(ret) {
                                callback(ret);
                            });
        };
        
        var buffer = [audioBuffer.getChannelData(0)];
        buffer.push(audioBuffer.getChannelData(1));
        
        // send the channel data from our buffer to the worker
        worker.postMessage({
                command: 'record',
                    buffer: buffer
                    });
        
        // ask the worker for a WAV
        worker.postMessage({
                command: 'exportWAV',
                    type: 'audio/wav'
                    });
}

const mapDispatchToProps = dispatch => {
    return {
        setShowConvolverModal: (show, sample) => dispatch(setShowConvolverModal(show, sample)),
        setContextualHelp: (c) => dispatch(setContextualHelp(c)),
        setShowSamples2D: (s) => dispatch(setShowSamples2D(s)),
        setSimilarSoundsToFind: (s) => dispatch(setSimilarSoundsToFind(s)),
        setSampleToExplore: (s) => dispatch(setSampleToExplore(s)),
    }
};

function  truncateName(str) {
    if (str === undefined || str === null) {
        return null;
    }
    const maxNameLength = 36;
    let x = str.length > maxNameLength ? str.substring(0, maxNameLength) + '...' : str;
    return x.trim();
}


export default {Sound: connect(null, mapDispatchToProps)(Sound), exportAsWAV: exportAsWAV};

